/*LIBRARY*/
import React from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/
import tutor_map_editor from "../../Assets/png_jpg/tutor_map_editor.png";
import tutor_map_viewer from "../../Assets/png_jpg/tutor_map_viewer.png";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SIDEBAR_LAYER_EMPTY = ({ layer, auth }) => {
  // local storage
  const language = localStorage?.language || auth.language;

  // global props
  const { page_layer_mode } = layer;

  // content
  return (
    <main>
      <h1 className="margin_bottom">
        {dict?.["Click the eye icon to view the data"]?.[language]}
      </h1>
      {page_layer_mode === "editor" ? (
        <img
          alt="tutor_map_editor"
          src={tutor_map_editor}
          style={{ width: "250px", maxWidth: "80%" }}
        />
      ) : (
        <img
          alt="tutorial_map_viewer"
          src={tutor_map_viewer}
          style={{ width: "250px", maxWidth: "80%" }}
        />
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, {})(SIDEBAR_LAYER_EMPTY);
